import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import SelectContent from "./components/pages/SelectContent/SelectContent";
import ChinaEurope from "./components/pages/ChinaEurope/ChinaEurope";
import UkraineEurope from "./components/pages/UkraineEurope/UkraineEurope";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

function App() {
  const { i18n } = useTranslation();
  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage");
    if (savedLanguage && savedLanguage !== i18n.language) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SelectContent />} />
        {/* <Route path="/china-europe" element={<ChinaEurope />} />
        <Route path="/ukraine-europe" element={<UkraineEurope />} /> */}

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
